/**
 * 에디터 Library VSE → 현재 ViewR Space attach (Packager attach-vse via Main API).
 */

import { apiCall } from "./base";
import type { StandaloneVseMetadataArtifact } from "../../types";

export interface LibraryAttachJobResponse {
  job_id: string;
  vdb_object_name: string;
}

export interface AttachLibraryVseParams {
  job_id: string;
  library_object_id: string;
  library_vse_gcs_path: string;
  viewr_gcs_path: string;
  space_index: number;
  vse_index: number;
  display_name?: string | null;
}

export interface AttachLibraryVseResponse {
  job_id: string;
  status: string;
  library_object_id: string;
  library_vse_gcs_path: string;
  viewr_gcs_path: string;
  space_index: number;
  vse_index: number;
  attach_mode: string;
  stage?: string | null;
  job_name?: string | null;
  queued_stages?: unknown[] | null;
}

export const createLibraryAttachJob = async (
  userToken: string | null,
): Promise<LibraryAttachJobResponse> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  };
  return (await apiCall(
    "/conversion/library-attach-job",
    options,
  )) as LibraryAttachJobResponse;
};

export const attachLibraryVse = async (
  params: AttachLibraryVseParams,
  userToken: string | null,
): Promise<AttachLibraryVseResponse> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      job_id: params.job_id,
      library_object_id: params.library_object_id,
      library_vse_gcs_path: params.library_vse_gcs_path,
      viewr_gcs_path: params.viewr_gcs_path,
      space_index: params.space_index,
      vse_index: params.vse_index,
      display_name: params.display_name ?? undefined,
    }),
  };
  return (await apiCall(
    "/conversion/attach-library-vse",
    options,
  )) as AttachLibraryVseResponse;
};

export interface EnsureLibraryVseMetadataResponse {
  status: "ready" | "pending";
  metadata_artifact?: StandaloneVseMetadataArtifact | null;
  job_id?: string | null;
}

/**
 * Library VSE의 material metadata sidecar 확보를 요청한다.
 *
 * sidecar가 이미 있으면 Converter가 접수 응답 전에 결과를 돌려주므로 대부분
 * `ready`로 끝난다. 새로 만들어야 하면 `pending` + job_id를 받아 기다린다.
 */
export const ensureLibraryVseMetadata = async (
  libraryObjectId: string,
  userToken: string | null,
): Promise<EnsureLibraryVseMetadataResponse> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ library_object_id: libraryObjectId }),
  };
  return (await apiCall(
    "/conversion/ensure-library-vse-metadata",
    options,
  )) as EnsureLibraryVseMetadataResponse;
};
